/**
 * Atlas add-first-product — derived Done-pill mission.
 *
 * Marked complete whenever `ctx.hasProduct` is true (see
 * `onboardingStateAdapter.readMissionState`). The entryRoute points at
 * Project Settings, where the Add Product modal lives — Atlas only needs to
 * bring the user to that page; modal invocation stays with the page UI.
 */
import type { AtlasMission } from '../atlas.types';

export const addFirstProductMission: AtlasMission = {
  id: 'add-first-product',
  title: 'Add your first product',
  description:
    'Pick what you analyze — products are the scope for Analytics, Forecast, and Reports.',
  kicker: 'Setup',
  entryRoute: '/settings?tab=project',
  featureKey: '',
  storage: 'derived',
  critical: true,
  steps: [],
};
